<template>
    <modal @close="$emit('close')">
        <p class="text-white font-bold text-xl mt-2" slot="header">Благодарим!</p>
        <div class="py-8">
            <h3 class="flex flex-col text-center w-full justify-center items-center text-xl">Вы успешно<br>
                зарегистрировались!</h3>
            <div class="flex flex-col text-center w-full justify-center items-center pt-4">
                <p>Ждем вас<br>24.09 в 19:00 в Maximilians</p>
                <br>
                <p>ул. Куйбышева, 44 Д</p>
            </div>
            <div class="flex flex-col text-center w-full justify-center items-center pt-10">
                <p>Выберите способ оплаты</p>
                <button class="bg-brand-green h-10 w-5/6 rounded-full text-white font-semibold mt-4"
                        @click="closePlace">Оплатить онлайн
                </button>
                <button class="mt-4 underline font-semibold">Оплатить на игре</button>
            </div>
        </div>
    </modal>
</template>

<script>
import ModalMixin from '../../../mixins/modals.js';
import Modal from '@/views/modals/base-modal';

export default {
  name: 'ThereArePlaces',
  components: { Modal },
  props: ['there_are_places', 'pay_online'],
  mixins: [ModalMixin],
  data() {
    return {
      ext: '',
      show: false,
      loaded: false,
      vale: this.pay_online,
      your_name: '',
      email: '',
    };
  },
  methods: {
    created() {
      this.loaded = true;
    },

    closePlace() {
      this.$emit('pay_online');
      this.vale = !this.vale;
    },
  },

  created() {
  },

};

</script>

<style scoped>

</style>
